(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ctr-giveaway-banner"] && !Shopify.designMode) return;
  try {
    (function () {
    var hoverQuery = window.matchMedia('(hover: hover) and (pointer: fine)');
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var OPEN_CLASS = 'is-open';
    var CLOSE_DELAY = 150;
    var HIDE_FALLBACK_DELAY = 1000;

    function initTooltip(banner) {
      if (banner.dataset.gbTooltipReady === 'true') return;

      var trigger = banner.querySelector('[data-gb-tooltip-trigger]');
      var panel = banner.querySelector('[data-gb-tooltip-panel]');
      var closeButton = banner.querySelector('[data-gb-tooltip-close]');
      var signupLink = banner.querySelector('[data-gb-tooltip-signup]');

      if (!trigger || !panel) return;

      banner.dataset.gbTooltipReady = 'true';

      var closeTimer = null;
      var hideTimer = null;
      var pinned = false;

      function isOpen() {
        return panel.classList.contains(OPEN_CLASS);
      }

      function cancelClose() {
        if (closeTimer) {
          clearTimeout(closeTimer);
          closeTimer = null;
        }
      }

      function open(pin) {
        cancelClose();
        clearTimeout(hideTimer);
        if (panel.hidden) {
          panel.hidden = false;
          void panel.offsetHeight;
        }
        panel.classList.add(OPEN_CLASS);
        trigger.setAttribute('aria-expanded', 'true');
        if (pin) pinned = true;
      }

      function hideIfClosed() {
        if (isOpen()) return;
        clearTimeout(hideTimer);
        panel.hidden = true;
      }

      function closeImmediately() {
        cancelClose();
        clearTimeout(hideTimer);
        panel.classList.remove(OPEN_CLASS);
        panel.hidden = true;
        trigger.setAttribute('aria-expanded', 'false');
        pinned = false;
      }

      function close(focusTrigger) {
        cancelClose();
        clearTimeout(hideTimer);
        panel.classList.remove(OPEN_CLASS);
        trigger.setAttribute('aria-expanded', 'false');
        pinned = false;
        if (reduceMotion.matches) {
          panel.hidden = true;
        } else {
          hideTimer = setTimeout(hideIfClosed, HIDE_FALLBACK_DELAY);
        }
        if (focusTrigger) trigger.focus();
      }

      panel.addEventListener('transitionend', function (event) {
        if (event.target === panel && panel.getAnimations().length === 0) hideIfClosed();
      });

      function scheduleClose() {
        if (pinned) return;
        cancelClose();
        closeTimer = setTimeout(function () {
          close(false);
        }, CLOSE_DELAY);
      }

      trigger.addEventListener('click', function () {
        if (isOpen() && pinned) {
          close(false);
        } else {
          open(true);
        }
      });

      trigger.addEventListener('mouseenter', function () {
        if (!hoverQuery.matches) return;
        if (isOpen()) {
          cancelClose();
        } else {
          open(false);
        }
      });

      panel.addEventListener('mouseenter', cancelClose);

      banner.addEventListener('mouseleave', function () {
        if (hoverQuery.matches) scheduleClose();
      });

      if (closeButton) {
        closeButton.addEventListener('click', function () {
          close(true);
        });
      }

      if (signupLink) {
        signupLink.addEventListener('click', closeImmediately);
      }

      banner.addEventListener('focusout', function (event) {
        if (isOpen() && event.relatedTarget && !banner.contains(event.relatedTarget)) close(false);
      });

      document.addEventListener('click', function (event) {
        if (isOpen() && !banner.contains(event.target)) close(false);
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && isOpen()) close(true);
      });

      banner.gbTooltip = {
        open: function () {
          open(true);
        },
        close: function () {
          close(false);
        },
      };
    }

    function initAll() {
      document.querySelectorAll('[data-gb-tooltip]').forEach(initTooltip);
    }

    initAll();
    document.addEventListener('shopify:section:load', initAll);

    document.addEventListener('shopify:block:select', function (event) {
      var banner = event.target;
      if (!banner || !banner.matches || !banner.matches('[data-gb-tooltip]')) return;
      initTooltip(banner);
      banner.gbTooltip.open();
    });

    document.addEventListener('shopify:block:deselect', function (event) {
      var banner = event.target;
      if (banner && banner.gbTooltip) banner.gbTooltip.close();
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
